import { getOcbDomain } from 'utils/getDomains';

function isVanity() {
    const domain = getOcbDomain();
    // eslint-disable-next-line prefer-destructuring
    const hostname = window.location.hostname;

    return !hostname.includes(domain);
}

if (window.location.protocol !== 'https:' && !isVanity()) {
    // This is a fallback for failed backend redirections
    // We've been suffering some bugs because the backend redirection has failed
    // More info: https://splashthat.atlassian.net/browse/SWP-44201
    window.location.href = window.location.href.replace('http://', 'https://');
}
